import { proxy } from "valtio";

type StoreType = {
    isActionsClicked: boolean;
    isEdited: boolean;
    actions: Function;
    validationAction: any;
    key: any

};

export const store = proxy<StoreType>({

    isActionsClicked: false,
    isEdited: false,
    actions: () => { },
    validationAction: {},
    key: ""
});



export function setIsEdited(isEdited: boolean): any {
    store.isEdited = isEdited;
}

export function setIsActionsClicked(isActionsClicked: boolean): any {
    store.isActionsClicked = isActionsClicked;
}

export function setValidationAction(validationAction: any): any {
    store.validationAction = validationAction;
}

export function setActions(actions: any): any {
    store.actions = actions;
}
export function setKey(key: any): any {
    store.key = key;
}

export default store;
